import { JsSettings, Snippet } from "../models";
import { isMobileDevice } from "../utils/common";
const nameComparator = (x: { name: string }, y: { name: string }) => x.name > y.name ? 1 : x.name < y.name ? -1 : 0;

export function snippetsVersionsEqual(a: JsSettings, b: JsSettings) {
    return a.widgets.sort(nameComparator).map(w => `${w.name}@${w.version}`).join(",")
        === b.widgets.sort(nameComparator).map(w => `${w.name}@${w.version}`).join(",");
}

export function snippetsEqual(a: Snippet, b: Snippet) {
    const eq = snippetsVersionsEqual(a.jsSettings, b.jsSettings) &&
        a.jsCode === b.jsCode &&
        a.htmlCode === b.htmlCode;
    console.log(eq);
    return eq;
}

export const snippetToDto = (snippet: Snippet): SnippetDto => ({
    js: snippet.jsCode,
    html: snippet.htmlCode,
    widgets: snippet.jsSettings.widgets
        .filter(w => w.version && w.version !== "off")
        .map(w => `${w.name}@${w.version}`).join(",")
});

export const dtoToSnippet = (dto: SnippetDto): Snippet => ({
    jsSettings: {
        widgets: dto.widgets ? dto.widgets.split(",").map(w => ({
            name: w.split("@")[0],
            version: w.split("@")[1]
        })) : [{ name: "suite", version: "pro/edge/suite" }]
    },
    id: dto.url || "basic",
    htmlCode: dto.html,
    jsCode: dto.js,
    title: dto.title,
    tagsIds: dto.tags ? dto.tags.split(",").map(id => Number.parseInt(id, 10)) : [],
    description: dto.Description,
    buttonHref: dto.ButtonHref,
    buttonText: dto.ButtonText,
    mode: dto.Mode === "Wide" || isMobileDevice ? "wide" : ""
});
